import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { lastValueFrom } from 'rxjs';

export const pagesTranslocoResolver: ResolveFn<unknown> = () => {
  const transloco = inject(TranslocoService);
  return lastValueFrom(transloco.load(`pages/${transloco.getActiveLang()}`));
};

export const ltiTranslocoResolver: ResolveFn<unknown> = () => {
  const transloco = inject(TranslocoService);
  return lastValueFrom(transloco.load(`lti/${transloco.getActiveLang()}`));
};

export const cameraTranslocoResolver: ResolveFn<unknown> = () => {
  const transloco = inject(TranslocoService);
  return lastValueFrom(transloco.load(`camera/${transloco.getActiveLang()}`));
};
